import React from 'react';
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import LabelMoveButtons from '../edit/LabelMoveButtons';
import { LabelMoveButtonsProps } from '../labelComponentPropTypes';

const LabelEditMovePopup: React.FC<LabelMoveButtonsProps> = (props) => {
    const { label, showMoveMenu } = props;
    if (!label) return null;

    return (
        <FloatingPanel
            className="light"
            selector={`#label-move-${label.id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={0}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showMoveMenu}
        >
            <PopupPanelMouseManager visible={showMoveMenu} popupId={PopupIds.LABEL_EDIT_MOVE} closePopup={() => {}}>
                <LabelMoveButtons {...props} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default LabelEditMovePopup;
